export default {
  SET_VARIANT_COLORS: (state, data) => {
    state.variantColors = data;
  },
  SET_VARIANT_COLOR: (state, data) => {
    state.variantColor = data;
  },
};
